import React, { useState, useEffect } from 'react'

import { useHistory } from "react-router-dom";

import { Line } from '@ant-design/charts';

import { Table, Tooltip,Tag, Input, Button, Space,message,Select} from 'antd';
import {   
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    UserOutlined,
    VideoCameraOutlined,
    UploadOutlined, 
    DeploymentUnitOutlined,
    SearchOutlined
} from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import './styles.scss';

import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import moment from 'moment'

import {GetOrders} from '../../../Redux/actions/orders'


const { Option } = Select;

const Index = ({currentData,seriesField,xField,yField}) => {

  const dispatch = useDispatch()   



    const [loading, setLoading] = useState(false)
    const [min, setMin] = useState(null)
    const [max, setMax] = useState(null)
    const [ave, setAve] = useState(null)


    const [timeGrouping, setTimeGrouping] = useState('By Date')
    const [currentSeriesField, setCurrentSeriesField] = useState('point_type')

    
    const [data, setData] = useState([])
   
    useEffect(() => {
      if(currentData){
        Analyze(currentData)   
      }
    },[currentData,timeGrouping]);

    useEffect(() => {
      if(seriesField){
        setCurrentSeriesField(currentSeriesField)   
      }
    },[seriesField]);

    

    const timeRangeRasterizer = (created_at) =>{
      const weekOfMonth =(input) => {
        const firstDayOfMonth = input.clone().startOf('month');
        const firstDayOfWeek = firstDayOfMonth.clone().startOf('week');
      
        const offset = firstDayOfMonth.diff(firstDayOfWeek, 'days');
      
        return Math.ceil((input.date() + offset) / 7);
      }

      switch(timeGrouping) {
        case "By Date":
          return(moment(created_at, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'))
        case "By Day of Month":         
            var day =  moment(created_at, 'YYYY-MM-DD HH:mm:ss').format('DD')
            console.log(day)

            return(day)
        case "By Week of Month":
          var week =  weekOfMonth(moment(created_at, 'YYYY-MM-DD HH:mm:ss'))
          return("week" + week)
        case "By WeekDay":
          var WeekDay =  moment(created_at, 'YYYY-MM-DD HH:mm:ss').format('d-dddd');
          return(WeekDay)
        case "By Hour":
          var hm =  moment(created_at, 'YYYY-MM-DD HH:mm:ss').format('HH');
          return(hm)
        case "By Week":
            var week =  weekOfMonth(moment(created_at, 'YYYY-MM-DD HH:mm:ss'))
            var month =  moment(created_at, 'YYYY-MM-DD HH:mm:ss').format('YYYY-M');          
            var text = month +"-week-"+week
            return(text)
        case "By Month":
            var month =  moment(created_at, 'YYYY-MM-DD HH:mm:ss').format('YYYY-M');
            return(month)
  
        default:
          // code block
      }
    }
  
    const Analyze = (datum) =>{
      var timeList =[]
      var seriesList =[]
      var newDatum  = datum.map(item=>{
        var currentDateTime = timeRangeRasterizer(item.created_at)
        if(!timeList.includes(currentDateTime)){
          timeList.push(currentDateTime)
        }
        if(!seriesList.includes(item[currentSeriesField])){
          seriesList.push(item[currentSeriesField])
        }
        var newItem ={
          ...item,
        
          dateTime:currentDateTime
        }
        return(newItem)
      })
      
      var proccesedData = []
     

      timeList.map(time=>{
        if(currentSeriesField == 'point_type'){
          var total = 0          
          newDatum.map(thing =>{
            if(thing.dateTime == time){
              total = total + thing[yField]
            }
          })
          var bago = {
            dateTime:time,  
            point_type:'actual',  
            value:total,      
            [yField]:total
          }
          proccesedData.push(bago)        
        }else{      
          var total = 0          
          newDatum.map(thing =>{
            if(thing.dateTime == time){
              total = total + thing[yField]
            }
          })
          var bago = {
            dateTime:time, 
            [yField]:total
          }
          proccesedData.push(bago)
        }       
      })
      var minimum = null
      var maximum = null
      var average = null
      var proccesedTotal =0 
      if(proccesedData.length >0){
        proccesedData.map(item=>{
          var count = item[yField]
          proccesedTotal = proccesedTotal + count
          if(!minimum){
            minimum = count
          }
          if(!maximum){
            maximum = count
          }
          if(count < minimum){
            minimum = count
          }
          if(count > maximum){
            maximum = count
          }

        })
        average = proccesedTotal/proccesedData.length
        setAve(average)
        setMin(minimum)
        setMax(maximum)
      }
     



      console.log('proccesedData',proccesedData)
      if(currentSeriesField == 'point_type'){
        var MovingAverageList= []
        var MAval = proccesedData.length >= 14 ? 7 :3
        var reversed = proccesedData.reverse()
        reversed.map((item,index) =>{         
          var bago2 = {
            dateTime:item.dateTime,  
            point_type:`MA-${MAval}`,       
            [yField]:getMA(reversed,index,MAval)
          }
          MovingAverageList.push(bago2)
        })
      }
      
      proccesedData = proccesedData.sort((a, b) => a.dateTime.localeCompare(b.dateTime)) 
      proccesedData = proccesedData.concat(MovingAverageList)
      proccesedData = proccesedData.sort((a, b) => a.dateTime.localeCompare(b.dateTime)) 

      setData(proccesedData)

    }

    const getMA =(MAData,index,window) =>{
        if(index+1 > window){
          var total = 0
          for (let i = index-window; i < index; i++) {
            var count = MAData[i].value 
            total = total + count
          }
          var result = total/window
          return(result)
        }
    }


    return(
      <div className="column_container">
        <div className="header">
          <div>
            <h1>{seriesField ? seriesField: null}-{yField}- Time </h1>
          </div>
          <div>
            <Select value={timeGrouping} style={{ width: 120 }} onChange={(e)=>{setTimeGrouping(e)}}>             
              <Option value="By Date">By Date</Option>
              <Option value="By Day of Month">By Day of Month</Option>
              <Option value="By Week of Month">By Week of Month</Option>              
              <Option value="By WeekDay">By WeekDay</Option>
              <Option value="By Hour">By Hour</Option>
              <Option value="By Week">By Week</Option>
              <Option value="By Month">By Month</Option>
          
            </Select>
          </div>
          <div>
            {ave ? <span>average:{ave.toFixed(3)}</span> : null}
            {min ? <span className="spanspacing">minumum:{min}</span> : null}
            {max ? <span className="spanspacing">maximum:{max}</span> : null}
          </div>
        </div>
        
        <Line 
        data={data}
        autoFit={true}
        style={{width:'100%'}}
        seriesField={currentSeriesField}
        // xAxis={{
        //   type: 'time',
        // }}
  
        xField={xField}
        yField={yField}
      
      />

      </div>
     
  
      
    )
}
  
export default Index
  